import { __rest, __assign } from './../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
var CustomersOutline = function (_a) {
  var _b = _a.fill,
    fill = _b === void 0 ? 'currentColor' : _b,
    props = __rest(_a, ["fill"]);
  return React__default.createElement("svg", __assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("g", {
    clipPath: "url(#clip0_3_8256)"
  }, React__default.createElement("path", {
    d: "M5.00016 1.66667C4.07933 1.66667 3.3335 2.41251 3.3335 3.33334V16.6667C3.3335 17.5875 4.07933 18.3333 5.00016 18.3333H9.28239C9.44739 17.7067 9.80659 17.145 10.3224 16.6667H5.00016V13.3333H11.7059C11.6909 13.195 11.6668 13.06 11.6668 12.9167C11.6668 12.4742 11.7548 12.0583 11.8898 11.6667H5.00016V8.33334H15.0002V9.20736C15.1385 9.19236 15.2735 9.16667 15.4168 9.16667C15.8593 9.16667 16.2752 9.25465 16.6668 9.38965V3.33334C16.6668 2.41251 15.921 1.66667 15.0002 1.66667H5.00016ZM5.00016 3.33334H15.0002V6.66667H5.00016V3.33334ZM15.4168 10.8333C14.8643 10.8333 14.3344 11.0528 13.9437 11.4435C13.553 11.8342 13.3335 12.3641 13.3335 12.9167C13.3335 13.4692 13.553 13.9991 13.9437 14.3898C14.3344 14.7805 14.8643 15 15.4168 15C15.9694 15 16.4993 14.7805 16.89 14.3898C17.2807 13.9991 17.5002 13.4692 17.5002 12.9167C17.5002 12.3641 17.2807 11.8342 16.89 11.4435C16.4993 11.0528 15.9694 10.8333 15.4168 10.8333ZM15.4168 16.6667C12.9135 16.6667 10.8335 17.6759 10.8335 19.1309V20H20.0002V19.1309C20.0002 17.6759 17.9202 16.6667 15.4168 16.6667Z",
    fill: fill
  })), React__default.createElement("defs", null, React__default.createElement("clipPath", {
    id: "clip0_3_8256"
  }, React__default.createElement("rect", {
    width: "20",
    height: "20",
    fill: "white"
  }))));
};
export { CustomersOutline as default };
//# sourceMappingURL=CustomersOutline.js.map
